<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>
    <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
            <!-- {{menuItems}} -->
            <ng-container *ngFor="let item of menuItems">
                <li class="menu-title" *ngIf="item.isTitle">
                    {{ item.label | translate }}
                </li>
                <!-- <li [hidden]="!(!item.isTitle  && item.isVisible)"> -->

                <li *ngIf="item.isVisible">

                    <a *ngIf="hasItems(item)" class="is-parent"
                        [ngClass]="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }" (click)="onMenuItemClick(item)">
                        <!-- <i class="bx {{ item.icon }}" *ngIf="item.icon"></i> -->
                        <i class=" {{ item.icon }}" *ngIf="item.icon"></i>
                        <span class="menu-text"> {{ item.label | translate }}</span>
                        <span class="badge rounded-pill float-end bg-{{ item.badge.variant }}" *ngIf="item.badge">{{
                            item.badge.text | translate }}</span>
                    </a>

                    <a [routerLink]="item.link" *ngIf="!hasItems(item)" class="side-nav-link-ref"
                        routerLinkActive="active" (click)="onMenuItemClick(item)">
                        <i class="{{ item.icon }}" *ngIf="item.icon"></i>
                        <span class="menu-text"> {{ item.label | translate }}</span>
                        <span class="badge rounded-pill bg-{{ item.badge.variant }} float-end" *ngIf="item.badge">{{
                            item.badge.text | translate }}</span>
                    </a>

                    <ul *ngIf="hasItems(item)" class="is-parent" aria-expanded="false">
                        <li *ngFor="let subitem of item.subItems">
                            <a [routerLink]="subitem.link" *ngIf="!hasItems(subitem) && subitem.isVisible"
                                class="side-nav-link-ref" [attr.data-parent]="subitem.parentId"
                        routerLinkActive="active" (click)="onMenuItemClick(subitem)">
                                
                                <i class="{{ subitem.icon }}"></i> <span class="menu-text">{{ subitem.label | translate
                                    }}</span>
                            </a>
                            <a *ngIf="hasItems(subitem) && subitem.isVisible" class="side-nav-link-a-ref has-arrow"
                                [attr.data-parent]="subitem.parentId">
                                <i class="{{ subitem.icon }}"></i> <span class="menu-text">{{ subitem.label | translate
                                    }}</span>
                            </a>
                            <ul *ngIf="hasItems(subitem)" class="sub-menu mm-collapse"
                                [attr.aria-expanded]="hasItems(subitem) ? true : false">
                                <li *ngFor="let subSubitem of subitem.subItems" class="sub-menu">
                                    <a [attr.data-parent]="subSubitem.parentId" [routerLink]="subSubitem.link"
                                        routerLinkActive="active" class="side-nav-link-ref" (click)="onMenuItemClick(subSubitem)">
                                        {{ subSubitem.label | translate }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ng-container>
        </ul>
    </div>
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
    <ngx-simplebar class="h-100" #componentRef>
        <div *ngIf="!isCondensed">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </div>
        <div *ngIf="isCondensed">
            <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
        </div>
    </ngx-simplebar>
</div>
<!-- Left Sidebar End -->

<!-- //Modal// -->
<div
  class="modal fade show"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-modal="true"
  [ngStyle]="{'display': showModuleModal ? 'block' : 'none', 'background-color': 'rgba(0,0,0,0.5)'}"
>
  <div class="modal-dialog" role="document" style="pointer-events:auto;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Module Available</h5>
        <button type="button" class="btn-close" id="close" (click)="closeModal()" aria-label="Close ">
        </button>
      </div>
      <div class="modal-body">
        <p>This module is now available in the new Lemur 2.0 Suite. Please click below to access the updated version.</p>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-light-primary font-weight-bold" (click)="closeModal()">Close</button> -->
        <button type="button" class="btn btn-primary font-weight-bold" (click)="onModalConfirm()">Go to Lemur 2.0</button>
      </div>
    </div>
  </div>
</div>
